import React from "react";

import { IntroBlock } from "components/Block";

import { Wrapper, Image } from "./styles";

const Map = ({ content }) => {
  return (
    <Wrapper>
      <IntroBlock content={content} shade="light" />
      <Image content={content.image} />
    </Wrapper>
  );
};

export default Map;
